import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from './TranslationContext';
import '../styles/header.css';
import '../styles/root.css';
import logo from '../assets/logo.png';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { translate, language, setLanguage } = useTranslation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleLanguageChange = (event) => {
    setLanguage(event.target.value);
  };

  return (
    <header className={`header ${isMenuOpen ? 'scrolled' : ''}`}>
      <div className="header-content">
        <Link to="/" className="logo-container">
          <img src={logo} alt="Logo" />
        </Link>
        <nav className="nav-desktop">
          <Link to="/entreprise">{translate('header').entreprise}</Link>
          <Link to="/savoirfaire">{translate('header').savoirfaire}</Link>
          <Link to="/values">{translate('header').values}</Link>
          <Link to="/equipe">{translate('header').equipe}</Link>
          <Link to="/contact">{translate('header').contact}</Link>
          <div className="language-selector">
            <select value={language} onChange={handleLanguageChange}>
              <option value="fr">Français</option>
              <option value="en">English</option>
            </select>
          </div>
        </nav>
        <div className={`hamburger ${isMenuOpen ? 'active' : ''}`} onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <nav className={`nav-mobile ${isMenuOpen ? 'active' : ''}`}>
          <div className="close-button" onClick={toggleMenu}>&times;</div>
          <Link to="/entreprise" onClick={toggleMenu}>{translate('header').entreprise}</Link>
          <Link to="/savoirfaire" onClick={toggleMenu}>{translate('header').savoirfaire}</Link>
          <Link to="/values" onClick={toggleMenu}>{translate('header').values}</Link>
          <Link to="/equipe" onClick={toggleMenu}>{translate('header').equipe}</Link>
          <Link to="/contact" onClick={toggleMenu}>{translate('header').contact}</Link>
          <div className="language-selector">
            <select value={language} onChange={handleLanguageChange}>
              <option value="fr">Français</option>
              <option value="en">Anglais</option>
            </select>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;
